/**
 * What the startup view says. It shows before the language texts have arrived from the API
 * (they are what it is waiting for), so these are the only texts in the app that live in the
 * client. The language is picked from the browser, as the user's own choice is not known yet.
 */
export interface StartupTexts {
    starting: string;
    waiting: string;
    failed: string;
    retry: string;
}

const texts: Record<"sv" | "en" | "da", StartupTexts> = {
    sv: {
        starting: "Startar LäraNära Author",
        waiting: "Väntar på svar från servern…",
        failed: "Kunde inte få kontakt med servern.",
        retry: "Försök igen",
    },
    en: {
        starting: "Starting LäraNära Author",
        waiting: "Waiting for the server to reply…",
        failed: "Could not reach the server.",
        retry: "Try again",
    },
    da: {
        starting: "Starter LäraNära Author",
        waiting: "Venter på svar fra serveren…",
        failed: "Kunne ikke få forbindelse til serveren.",
        retry: "Prøv igen",
    },
};

/** The first of the browser's languages we have texts for, else Swedish. */
export function startupTexts(browserLanguages: readonly string[]): StartupTexts {
    for (const tag of browserLanguages) {
        const short = tag.toLowerCase().split("-")[0];
        if (short === "sv" || short === "en" || short === "da") {
            return texts[short];
        }
        // Norwegian reads Danish more easily than English.
        if (short === "nb" || short === "nn" || short === "no") {
            return texts.da;
        }
    }
    return texts.sv;
}
